import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTableDataSource } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { HowdenControllerWithParams } from '@app/core/helpers/howden-controller-with-params';
import { AppManagementService } from '@app/core/services/app/app-management.service';
import { IRequestShortDto } from '@app/shared/models/api/teladoc/request-short-dto';
import { TeladocService } from '@app/shared/services/api/teladoc.service';
import { RequestsListComponent } from '@features/teladoc-events/components/requests-list/requests-list.component';
import { RequestMapper } from '@features/teladoc-events/mappers/request-mapper';
import { ShowManualRequestService } from '@features/teladoc-events/services/models/show-manual-request.service';
import { ShowRequestsFilterFormDialogService } from '@features/teladoc-events/services/models/show-requests-filter-form-dialog.service';
import { DialogResultTypes, HowdenAlertService, HowdenAskForDataService, HowdenLoaderService, IHowdenAskForData, RolEvalHideDirective } from '@howdeniberia/core-front';
import { TelesuscripcionAccessRoles } from '@shared/models/api/teladoc/telesuscripcion-access-roles';
import { IRequestFrontFilterAppDto } from '@sharedModels/api/teladoc/request-front-filter-app-dto';
import { IRequestFormFilterDialogResult } from '@sharedModels/custom/request-form-filter-dialog-result';
import { IRegionsDto } from '../../models/ui/regions-dto';

@Component({
  selector: 'howden-teladoc-events-page',
  templateUrl: './teladoc-events-page.component.html',
  styleUrls: ['./teladoc-events-page.component.scss'],
  imports: [MatFabButton, MatIcon, MatTooltip, RequestsListComponent, RolEvalHideDirective]
})
export class TeladocEventsPageComponent extends HowdenControllerWithParams implements OnInit, AfterViewInit {
  protected override activatedRoute: ActivatedRoute;
  private readonly appSrv = inject(AppManagementService);
  private readonly teladocSrv = inject(TeladocService);
  private readonly filtersSrv = inject(ShowRequestsFilterFormDialogService);
  private readonly alertSrv = inject(HowdenAlertService);
  private readonly loaderSrv = inject(HowdenLoaderService);
  private readonly askFordataSrv = inject(HowdenAskForDataService);
  private showManualSrv = inject(ShowManualRequestService);
  private readonly router = inject(Router);

  teladocPhone = 932532183;
  teladocPhoneStr = '932 532 183';
  data: Array<IRequestShortDto> = [];
  dataSource: MatTableDataSource<IRequestShortDto>;
  version = '';
  filtered = false;
  filterApp: IRequestFrontFilterAppDto | undefined = undefined;
  mapper: RequestMapper = new RequestMapper();
  searchAll = false;
  allowedDirectRequest = TelesuscripcionAccessRoles.TELESUSCRIPCIONTECNIC;
  isManual = false;
  @ViewChild(RequestsListComponent) table!: RequestsListComponent;

  constructor() {
    const activatedRoute = inject(ActivatedRoute);

    super(activatedRoute);

    this.activatedRoute = activatedRoute;
  }

  ngAfterViewInit(): void {
    if (!this.isManual) {
      this.readOffices();
    }
  }

  ngOnInit(): void {
    this.readParams();
  }

  readOffices(): void {
    this.loaderSrv.showSpinner();
    // read offices and update to app data
    this.teladocSrv.getOffices().subscribe({
      next: (data: Array<IRegionsDto>) => {
        this.appSrv.avaliableRegions = data;
        this.loaderSrv.hideSpinner();
      },
      error: (err) => {
        this.alertSrv.error('API no disponible', '', true, true);
        this.loaderSrv.hideSpinner();
      }
    });
  }

  /* #region Params */
  readParams() {
    this.isManual = this.activatedRoute.snapshot.url[0].path.toLocaleLowerCase() === 'manual';
    this.searchAll = this.activatedRoute.snapshot.routeConfig?.path === 'requests';
    if (this.isManual) {
      this.activatedRoute.queryParamMap.subscribe(data => {
        this.processManualRequest(data);
      });
    } else if (!this.searchAll) {
      this.getRequests();
    }
  }
  /* #endregion */

  /* #region Manual */
  processManualRequest(data: ParamMap): void {
    const mapper: RequestMapper = new RequestMapper();
    const viewModel = mapper.queryParamsToRequestViewModel(data)
    this.showManualSrv.open(viewModel).subscribe(result => {
      if (result) {
        // generate new manual request
        this.loaderSrv.showSpinner();
        this.teladocSrv.addManualRequest(mapper.requestViewModelToRequestNewDto(result)).subscribe({
          next: (requestNew) => {
            this.alertSrv.success('Éxito', 'Petición registrada correctamente');
            //Redireccionamos a la petición
            this.router.navigate([`request/${requestNew.requestId}`]);
          },
          error: (err) => {
            let msg = err ? err.error?.title : '';
            if (err && err.error?.detail) {
              msg = `${msg}=> ${err.error?.detail}`;
            }
            this.alertSrv.error('ERROR', msg, true, true);
            //Redireccionamos a todas la petición del proyecto
            this.router.navigate([`requests/proyect/${viewModel.proyectId}`]);
          },
        });
      }
    });
  }
  /* #endregion */

  /* #region Get Requests */
  getRequests(): void {
    this.teladocSrv.getRequestShort(this.params).subscribe({
      next: (result) => {
        this.data = result;
      },
      error: (err) => {
        this.alertSrv.error('API no disponible', '', true, true);
        this.loaderSrv.hideSpinner();
      }
    });
  }

  getRequestsFiltered(): void {
    this.loaderSrv.showSpinner();
    const filterValues = this.mapper.iRequestFrontFilterAppDtoToIRequestFrontFilterDto(this.filterApp);
    this.teladocSrv.getFilteredRequestShort(filterValues).subscribe({
      next: (result) => {
        this.data = result;
        // this.data = result.filter(x => x.done === true || x.deleted === true);
        // this.table.loadData(this.data, 5);
        this.loaderSrv.hideSpinner();
      },
      error: (err) => {
        this.alertSrv.error('APi not avaliable', err.message, true, true);
        this.loaderSrv.hideSpinner();
      }
    });
  }
  /* #endregion */

  /* #region Buttons */
  reload(): void {
    this.getRequestsFiltered();
  }

  showFilter(): void {
    this.filtersSrv.open().subscribe({
      next: (result: IRequestFormFilterDialogResult | undefined) => {
        this.filtered = result && result.ok ? true : false;
        this.filterApp = result && result.ok ? this.mapper.requestFilterFormViewModelToIRequestFrontFilterAppDto(result.value) : undefined;
        if (result && result.ok) {
          this.appSrv.lastRequestFilter = this.filterApp;
        }
      }
    });
  }

  goToRequest(): void {
    const options = {
      title: 'Pon un número de solicitud',
      allowCancel: true
    } as IHowdenAskForData;

    this.askFordataSrv.open(options).subscribe(userResponse => {
      if (userResponse && userResponse.result === DialogResultTypes.OK && !isNaN(Number(userResponse.resultData))) {
        const requestId = +`${userResponse.resultData}`;
        this.router.navigateByUrl(`/request/${requestId}`);
      }
    });
  }
  /* #endregion */
}
